import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { useModal } from 'hooks/modal/useModal';

import ModalCreate from '../Modals/ModalCreate';
import { FilterDashboardFooterLink } from '../types';

import Filter from './Filter/Filter';

interface DashboardHeaderProps {
  totalCount: number;
  refreshDashboard: () => void;
  setFilter: (value: Partial<FilterDashboardFooterLink>) => void;
  filter: Partial<FilterDashboardFooterLink>;
}

function DashboardHeader({
  totalCount,
  refreshDashboard,
  setFilter,
  filter,
}: DashboardHeaderProps): React.ReactElement {
  const countString = `${totalCount} lien${totalCount > 1 ? 's' : ''} trouvé${
    totalCount > 1 ? 's' : ''
  }`;

  const modalCreation = useModal();

  return (
    <div>
      <div className="dashboard-header-fields header-referentiels">
        <Filter filter={filter} setFilter={setFilter} />
        <AntdButton
          icon={<PlusOutlined />}
          type={'primary'}
          shape={'round'}
          onClick={modalCreation.open}
        >
          Créer un lien
        </AntdButton>
        <ModalCreate
          visible={modalCreation.visible}
          close={modalCreation.close}
          refreshDashboard={refreshDashboard}
        />
      </div>
      <p>{countString}</p>
    </div>
  );
}

export default DashboardHeader;
